import React from 'react'

import { Spinner } from './LoadingSpinner'

interface PageStatusBlockerProps {
    isLoading: boolean
    loadingText: string
    isError: boolean
    children?: React.ReactNode
}

export const PageStatusBlocker: React.FC = ({
    isLoading,
    loadingText,
    isError,
    children,
}: PageStatusBlockerProps) => (
    <div className="min-h-screen flex justify-center items-center">
        {isLoading ? (
            <div className="flex flex-col gap-3">
                <Spinner className="text-blue-700" />
                <span className="text-base text-blue-700 leading-[22px]">{loadingText}</span>
            </div>
        ) : isError ? (
            <div className="flex flex-col gap-3">
                <img src={require('../../assets/error_circle_icon.svg')} className="h-10" />
                <span className="text-base text-center leading-[22px]">
                    ขออภัย ไม่สามารถทำรายการได้
                    <br />
                    กรุณาลองใหม่อีกครั้ง
                </span>
            </div>
        ) : (
            <>{children}</>
        )}
    </div>
)
